import { Injectable, InjectionToken } from '@angular/core';
import {
  ICompareWordsDto,
  ICompareWordsResponseDto,
  IEvaluateShortAnswerFromTextDto,
  IEvaluateShortAnswerResponseDto,
  IExplainTextDto,
  IExplainTextResponseDto,
  IExtractWordsDto,
  IGenerateQuizFromWordsDto,
  IGenerateShortAnswerFromTextDto,
  IGenerateShortAnswerFromTextResponseDto,
  IGenerateStoryDto,
  IGenerateStoryResponseDto,
  IGetEtymologyDto,
  IGetEtymologyResponseDto,
  IGetTopicWordsDto,
  IGetTopicWordsResponseDto,
  IPromptLLMDto,
  IPromptLLMResponseDto,
  IQuizResponseDto,
  IRephraseSentenceDto,
  IRephraseSentenceResponseDto,
  ITranslateDto,
  ITranslateResponseDto,
  ITranslateWordDto,
  ITranslateWordResponseDto,
} from '@shared';
import { Observable } from 'rxjs';

@Injectable()
export abstract class AiGatewayService {
  abstract prompt(payload: IPromptLLMDto): Observable<IPromptLLMResponseDto>;
  abstract getEtymology(
    payload: IGetEtymologyDto,
  ): Observable<IGetEtymologyResponseDto>;
  abstract generateStory(
    payload: IGenerateStoryDto,
  ): Observable<IGenerateStoryResponseDto>;
  abstract translateWord(
    payload: ITranslateWordDto,
  ): Observable<ITranslateWordResponseDto>;
  abstract compareWords(
    payload: ICompareWordsDto,
  ): Observable<ICompareWordsResponseDto>;
  abstract getTopicWords(
    payload: IGetTopicWordsDto,
  ): Observable<IGetTopicWordsResponseDto>;
  abstract rephraseSentence(
    payload: IRephraseSentenceDto,
  ): Observable<IRephraseSentenceResponseDto>;
  abstract translate(payload: ITranslateDto): Observable<ITranslateResponseDto>;
  abstract explainText(
    payload: IExplainTextDto,
  ): Observable<IExplainTextResponseDto>;
  abstract extractWords(
    payload: IExtractWordsDto,
  ): Observable<IGetTopicWordsResponseDto>;
  abstract generateShortAnswerFromText(
    payload: IGenerateShortAnswerFromTextDto,
  ): Observable<IGenerateShortAnswerFromTextResponseDto>;
  abstract evaluateShortAnswerFromText(
    payload: IEvaluateShortAnswerFromTextDto,
  ): Observable<IEvaluateShortAnswerResponseDto>;
  abstract generateQuiz(
    payload: IGenerateQuizFromWordsDto,
  ): Observable<IQuizResponseDto>;
}

export const AI_GATEWAY_SERVICE = new InjectionToken<AiGatewayService>(
  'AI_GATEWAY_SERVICE',
);
